









































import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import MyMixin from "@/mixins/datemixin";
import DateChooser from "@/components/dateChooser.vue";
import DateType from "@/shared/DateType";
@Component({
  components: { DateChooser },
})
export default class ExpandableDateChooser extends mixins(MyMixin) {
  @Prop({ default: new DateType() }) public dateType!: DateType;
  @Prop({ default: true }) public showWeek!: boolean;

  public updateDate() {
    this.$emit("updateDate", this.dateType);
  }
}
